import { createApp } from 'vue'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import axios from 'axios';

axios.defaults.withCredentials = true;
const app = createApp(App)

app.use(VueCookies).mount('#app')
